<script>
import {
  clientComputed,
  clientMethods,
  authComputed,
  adminPanelMethods,
  adminPanelComputed,
} from '@state/helpers';
import { adminPanelMixin } from '@mixins/admin-panel-mixin';
import SearchInput from '@components/search-input/search-input.vue';

export default {
  components: {
    SearchInput,
  },
  props: {},
  data() {
    return {
      placeholder: require('@assets/images/placeholder-photo-upload.svg'),
      initialClientList: null,
      searchComponentKey: 0,
      searchOpts: { keys: ['profile.firstName', 'profile.lastName', 'email'] },
    };
  },
  mixins: [adminPanelMixin],
  computed: {
    ...clientComputed,
    ...authComputed,
    ...adminPanelComputed,
  },
  methods: {
    ...clientMethods,
    ...adminPanelMethods,
    async onGetAllClients() {
      try {
        await this.getAllClient({ trainerId: this.trainerId });
      } catch (e) {
        console.log(e);
      }
    },
    async close() {
      this.setSelectedClient(null);
      this.setAllClient(this.allClientClone);
      this.searchComponentKey++;
    },
    onFilterResults(val) {
      this.setAllClient(val);
    },
    selectClient(client) {
      if (client.program) {
        this.setSelectedClient(client);
        this.$bvModal.hide('item-select-modal');
        this.$bvModal.show('confirmation-program-client-modal');
        this.setAllClient(this.allClientClone);
      } else {
        // Handle client selection
      }
    },
    getAvatar(client) {
      return client &&
        client.profile &&
        client.profile.mediaAssets &&
        client.profile.mediaAssets.avatarImage &&
        client.profile.mediaAssets.avatarImage.url
        ? client.profile.mediaAssets.avatarImage.url
        : this.placeholder;
    },
    async showAdminPanel(component, data = null, size = '') {
      await this.setPanelContent(this.getPanelContent(component, data, size));
      this.setShowAdminPanel();
      this.$bvModal.hide('item-select-modal');
      this.setAllClient(this.allClientClone);
    },
  },
};
</script>

<template class="modal-item-select">
  <b-modal
    id="item-select-modal"
    centered
    :hide-footer="true"
    size="lg"
    no-stacking
    @close="close"
  >
    <template slot="modal-title">
      Assign Program to Client
    </template>

    <template slot="default">
      <div>
        <div class="divider" />
        <div class="client-search-input-wrapper">
          <img
            class="icon-add-user"
            src="@assets/images/icon-add-user.svg"
            @click="showAdminPanel('ClientForm', null, 'lg')"
          />
          <SearchInput
            :key="searchComponentKey"
            :square="true"
            :list="allClientClone"
            :options="searchOpts"
            :hasCustomIcon="true"
            @filter-results="onFilterResults"
          />
        </div>
        <ul class="list-select-client">
          <li
            class="list-select-client-item"
            v-for="client in allClient"
            :key="client._id"
            @click="selectClient(client)"
          >
            <div class="client-wrapper">
              <img :src="getAvatar(client)" />
              {{ `${client.profile.firstName} ${client.profile.lastName}` }}
            </div>
            <!-- TODO: We will use this once we're able to know if client been assined to a program -->
            <!-- <div class="client-program-wrapper">
              <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:class="'icon-calendar-alt'" v-bind:svg-inline="''" v-if="client.program" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.4 0v1.2H3.6V0H2.4v1.2h-.6c-.666 0-1.194.54-1.194 1.2L.6 10.8c0 .66.534 1.2 1.2 1.2h8.4c.66 0 1.2-.54 1.2-1.2V2.4c0-.66-.54-1.2-1.2-1.2h-.6V0H8.4zM9 6.6H6v3h3v-3zm-7.2 4.2h8.4V4.2H1.8v6.6z" fill="#fff"/></svg>
              <span class="client-program-title" v-if="client.program">{{
                client.program.label
              }}</span>
              <span class="no-program-notice" v-if="!client.program"
                >No Program Assigned</span
              >
            </div> -->
          </li>
        </ul>
      </div>
    </template>
  </b-modal>
</template>

i think a standard UTC datatime in ISO woul

<style lang="scss" scoped>
@import '@design';
// stylelint-disable selector-pseudo-element-no-unknown

.modal-body > div {
  max-height: 26.7rem;
  min-height: 26.7rem;
  overflow: scroll;
  width: 100%;
}

.divider {
  background-color: $color-off-white;
  height: 4px;
}

.client-search-input-wrapper {
  align-items: center;
  display: flex;
  position: relative;

  .icon-add-user {
    left: 3.2rem;
    position: relative;
    z-index: 1;

    &:hover {
      cursor: pointer;
    }
  }
}

.search-input-wrapper {
  width: 100%;

  ::v-deep .input-icon-wrapper {
    img {
      padding-left: 2.2rem;
    }

    ::v-deep .input {
      background-color: $color-light-gray-ten;
      border-radius: unset;
      padding-left: 30.3rem;
    }
  }
  &.square {
    ::v-deep .input-icon-wrapper {
      .input {
        border-color: white;
        &:focus {
          border-color: white;
        }
      }
    }
  }
}

::v-deep .modal-header {
  align-items: center;
  background-color: white !important;
  border-bottom: unset;
  border-top-left-radius: 1rem !important;
  border-top-right-radius: 1rem !important;
  display: flex;
  justify-content: center;
  h5 {
    color: $color-black-one;
    font-size: 2.2rem;
    font-style: normal;
    font-weight: 900;
    letter-spacing: -0.233333px;
    // line-height: 28px;
    text-align: center;
  }
  .close {
    color: black !important;
    margin: -1rem -1rem -1rem -1rem;
    position: absolute;
    right: 1.8rem;
    top: 1.6rem;
  }
}
::v-deep .modal-content {
  border: unset;
  border-top-left-radius: 1rem !important;
  border-top-right-radius: 1rem !important;
}

.list-select-client {
  background-color: $color-off-white;
  height: inherit;
  margin-bottom: 0;
  min-height: 22.4rem;
  padding-bottom: 1rem !important;
  padding-top: 1rem !important;

  .list-select-client-item {
    border-bottom: 1px solid $color-light-gray;
    display: flex;
    margin: 0 2.4rem 0 3.3rem;
    padding: 0.5rem 0.1rem 0.5rem 0.3rem;
    transition: background-color $duration-animation-base ease-in-out;
    &:hover {
      background-color: white;
      cursor: pointer;
    }
    &:last-child {
      &:not(:only-child) {
        border-bottom: unset;
      }
    }

    .client-wrapper {
      flex: 1;

      img {
        border-radius: $base-border-radius;
        height: 2.5rem;
        margin-right: 1.1rem;
        object-fit: cover;
        width: 2.5rem;
      }
    }

    .client-program-wrapper {
      flex: 1;

      .icon-calendar-alt {
        margin-right: 1rem;

        path {
          fill: black;
        }
      }

      .no-program-notice {
        margin-left: 2.2rem;
      }
    }
  }
}
</style>
